import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import './sidebar.css'

interface SidebarProps {
  onToggleCollapse: (collapsed: boolean) => void
  onToggleHidden: (hidden: boolean) => void
}

const Sidebar: React.FC<SidebarProps> = ({ onToggleCollapse, onToggleHidden }) => {
  const location = useLocation()

  const isActive = (path: string) => {
    return location.pathname === path
  }

  return (
    <div className="affiliate-sidebar-wrapper">
      <div className="affiliate-logo-container">
        <img src="/logo.png" alt="Logo" className="affiliate-logo-icon" />
        <div className="affiliate-logo-text">Affiliate Panel</div>
        <i className='bx bx-menu' id="btn" onClick={() => onToggleCollapse(true)}></i>
      </div>
      <ul className="affiliate-nav-list">
        <li className="affiliate-nav-item">
          <Link to="/affilate" className={`affiliate-nav-link ${isActive('/affilate') ? 'active' : ''}`}>
            <i className={`bx bx-home affiliate-nav-icon`}></i>
            <span className="affiliate-link-text">Home</span>
          </Link>
        </li>
        <li className="affiliate-nav-item">
          <Link to="/affilate/users" className={`affiliate-nav-link ${isActive('/affilate/users') ? 'active' : ''}`}>
            <i className={`bx bx-user affiliate-nav-icon`}></i>
            <span className="affiliate-link-text">Reff. Users</span>
          </Link>
        </li>
        <li className="affiliate-nav-item">
          <Link to="/affilate/account-statement" className={`affiliate-nav-link ${isActive('/affilate/account-statement') ? 'active' : ''}`}>
            <i className={`bx bx-file affiliate-nav-icon`}></i>
            <span className="affiliate-link-text">Account Statement</span>
          </Link>
        </li>
        <li className="affiliate-nav-item">
          <Link to="/affilate/commission" className={`affiliate-nav-link ${isActive('/affilate/commission') ? 'active' : ''}`}>
            <i className={`bx bx-money affiliate-nav-icon`}></i>
            <span className="affiliate-link-text">My Commission</span>
          </Link>
        </li>
      </ul>
    </div>
  )
}

export default Sidebar